import styled from "styled-components";

export const CarrousselContainer = styled.div`
  
    height: 100%;
    width: 100%;
`;

export const galleryButton = styled.button`
    width: auto;
    height: auto;
    color: rgb(7, 7, 7);
    background-color: rgb(248, 248, 248);
    font-family: "SpartanMB-Thin.oft";

`
